<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pr-0 note">
  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0 borderedNotes">
    @if (_pageState == pageState.EDIT) {
      <div class="col-12">
        <span class="d-inline-block mt-1">Notes</span>
        <button (click)="_isEditNote ? editNote() : createNote()"
          class="saveHistoryButton mr-0">
          <img class="saveHistory"
            [src]="'/assets/menu/'+ _theme +'/save-icon.svg'" />Save
          </button>
        </div>
      }

      @if (_pageState == pageState.EDIT) {
        <div class="col-12 p-0">
          <div class="formsMenuSeparator"></div>
        </div>
      }

      @if (_pageState  != pageState.VIEW) {
        <div class="col-12 mt-3 mb-3">
          <textarea rows="2"
            cols="20"
            class="note_textarea"
            placeholder="Enter Notes...."
            [(ngModel)]="_note"
            [ngModelOptions]="{standalone : true}"
          maxlength="500"></textarea>
        </div>
      }

      <div class="col-12 p-0 mt-3 mb-2">
        <div class="col-12 mb-2">
          <span>Notes History</span>
        </div>

        <div class="col-12 p-0 mb-2">
          <div class="formsMenuSeparator"></div>
        </div>

        @if (_notes && _notes.length > 0) {
          @for (note of _notes; track note; let i = $index) {
            <div class="col-12 notesHistoryItem">
              <span>
                <textarea [readonly]="i !== _index"
                  class="col-11 p-0"
                  [ngClass]="{'input-disabling': i !== _index}"
                  type="text"
                  [(ngModel)]="note.description"
                  [ngModelOptions]="{standalone : true}"
                  (change)="editableNote(note)"
                rows="1"></textarea>
              </span>
              @if (_pageState == pageState.EDIT) {
                <a class="wikilink pointer">
                  <img class="edithistryicon"
                    (click)="processEditNote(i)"
                    [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                  </a>
                }
              </div>
              <div class="col-12 mb-3">
                <small>
                  <span class="text-primary">{{note.createdByUserName}}</span> -
                  {{note.createdOn | date: 'shortDate'}}
                </small>
              </div>
            }
          }
        </div>
      </div>
    </div>
